interface IUnappliedPendingCourse {
  display: string;
  status: string;
}

export class UnappliedCredits {

  id: number = 0;
  courses: string[] = [];
  pending_courses: IUnappliedPendingCourse[] = [];
  exams: string[] = [];
  has_unapplied_credits: Boolean;

  constructor(unapplied_credits: any) {
    _.merge(this, unapplied_credits);
    this.has_unapplied_credits = !_.every([this.courses, this.pending_courses, this.exams], _.isEmpty);
  }

  static build(unapplied_credits: any): UnappliedCredits {
    return new UnappliedCredits(unapplied_credits);
  }
}

angular
  .module('capability-ng-transfer')
  .factory(
    'ngUnappliedCreditsBuilder',
    function(): typeof UnappliedCredits {
      return UnappliedCredits;
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/unapplied_credits_builder.ts